// The current player's league and club, for the league modules on ?live=1 (Ben, 2026-10-16):
// - a fresh League Table / Match Results opens on the player's league (Rice → the Premier
//   League), as Squad already opens on the player's club;
// - selected ones follow a linked player change to it (canvas/league-follow.ts).
// The snapshot site keeps the original demo (a fresh table opens on FAWSL), so there it's null.

import type { CompetitionId } from "../data/league.js";
import type { PlayerId } from "../data/players.js";
import { getStickyPlayer } from "../canvas/sticky-player.js";
import { LIVE } from "../live/flag.js";
import { liveApi } from "../live/api.js";
import { useLiveQuery } from "../live/query.js";
import { loadStickyClub } from "../live/squad.js";

export interface StickyClub {
  competitionId: CompetitionId | null;
  /** The club's name, as Match Results' team filter lists it. */
  teamName: string | null;
  /** The club's id, as the League Table's rows carry it. */
  teamId: number | null;
}

function useLiveStickyClub(): StickyClub | null {
  const sticky = getStickyPlayer();
  return useLiveQuery(sticky === null ? null : `league:sticky:${sticky}`, () =>
    loadStickyClub(liveApi(), sticky as PlayerId),
  );
}

const noStickyClub = (): StickyClub | null => null;

export const useStickyClub: () => StickyClub | null = LIVE ? useLiveStickyClub : noStickyClub;
